import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles.css';

const style = document.createElement('style');
style.textContent = '@keyframes spin { from { transform: rotate(0) } to { transform: rotate(360deg) } }';
document.head.appendChild(style);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
